import React, {useState} from "react";
import {useTheme} from "../../../../../connectui/theme/ThemeProvider";
import {buildStyles} from "../../../../../connectui/component/buildStyles";
import Container from "../../../../../connectui/component/layout/Container";
import DropdownExpand from "../../../../../connectui/component/display/dropdown/DropdownExpand";
import FlexContainer from "../../../../../connectui/component/layout/FlexContainer";
import Text from "../../../../../connectui/component/display/Text";
import SvgIcon from "../../../../../connectui/component/display/SvgIcon";
import ICONS from "../../../../../connectui/icons/iconMap";
import BookingFeesUpsells from "../../../../../components/Panels/Booking/BookingFeesUpsells";

const useStyles = (theme) =>
  buildStyles({
    cardContainer: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      padding: theme.spacing(2, 3, 0),
      borderBottom: `1px solid ${theme.colors.border}`,
    },
  });

const UpsellsCard = ({booking, guest}) => {
  const {theme} = useTheme();
  const classes = useStyles(theme);

  const [expanded, setExpanded] = useState(false);
  const [statusData, setStatusData] = useState(null);

  return (
    <Container
      className={classes.cardContainer}
      sx={{display: statusData?.total === 0 ? "none" : "flex"}}
    >
      <DropdownExpand
        customLabel={
          <FlexContainer
            justifyContent={"space-between"}
            alignItems={"center"}
            sx={{width: "100%"}}
          >
            <FlexContainer alignItems={"center"} gap={theme.spacing(1)}>
              <SvgIcon
                component={ICONS["dollar-sign"]}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "16px",
                  height: "16px",
                  color: theme.colors.textPrimary,
                }}
              />
              <Text variant="textSM" weight="medium">
                {"Upsells"}
              </Text>
              <Text
                variant="textXS"
                weight="medium"
                color="textSecondary"
                sx={{marginLeft: theme.spacing(1)}}
              >
                {`${statusData?.paid ?? 0}/${statusData?.total ?? 0} paid`}
              </Text>
            </FlexContainer>
          </FlexContainer>
        }
        divider={false}
        expanded={expanded === true}
        onExpand={() => setExpanded(!expanded)}
      >
        <BookingFeesUpsells
          guest={guest}
          newExpand={true}
          setStatusData={setStatusData}
          booking={booking}
        />
      </DropdownExpand>
    </Container>
  );
};
export default UpsellsCard;
